var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "soy",
    width: "100%",
    height: "100%",
    viewBox: "0 0 100 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "soja") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "soja",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#000000",
    strokeWidth: 2,
    cx: 50,
    cy: 38,
    r: 37
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6661019,33.3451612 C61.4296776,35.6922724 58.9732122,36.2223864 57.227672,35.4611138 C55.237379,34.5925175 55.3411383,31.6745143 56.7436272,29.4705013 C58.1461161,27.2672388 60.9625123,26.125455 62.3074123,27.4811357 C63.9082354,29.094243 63.867526,31.0645956 62.6661019,33.3451612 Z M53.5566264,45.0574515 C51.7011212,46.9277354 48.6027378,47.5198919 46.6218774,45.9793343 C44.7854858,44.5516042 45.4733259,41.1897964 47.6808185,39.0108006 C49.8883112,36.8318047 52.8099562,36.2216358 54.6155675,38.0884174 C55.7750411,39.2879908 54.8709943,43.7327921 53.5566264,45.0574515 Z M42.1453315,51.2934824 C40.0803217,52.5953761 37.5079337,52.5348346 36.6413694,51.87263 C35.2743771,50.8271623 35.0030638,48.9701375 37.5776858,46.3753562 C39.3001408,44.6394145 41.9179545,44.3524675 43.0813997,45.7962086 C44.5640663,47.6367221 44.2324335,49.9770787 42.1453315,51.2934824 Z M63.2437287,20 C63.2437287,20 63.0357136,20.9058719 62.5067394,21.8990537 C61.9772689,22.8922355 61.3825143,23.3988332 61.3825143,23.3988332 C60.3871195,24.4020219 57.9914699,24.4390473 55.5034795,26.9465187 C52.7943178,29.6766428 51.8666893,33.2861207 51.8666893,33.2861207 C51.8666893,33.2861207 48.1457498,33.391443 45.2891406,36.2704193 C43.0128888,38.5639938 41.4599736,42.1399487 41.4599736,42.1399487 C41.4599736,42.1399487 38.5849956,42.4741781 35.3413987,45.7431722 C32.4664206,48.6404111 32,52.1323082 32,52.1323082 C32,52.1323082 35.4476404,54.1622017 39.5064183,53.9895832 C44.0770427,53.7951998 46.7308495,51.2409463 46.7308495,51.2409463 C46.7308495,51.2409463 50.2693414,51.6494768 54.729256,48.0832786 C58.7716509,44.8510598 59.3363699,41.2478362 59.3363699,41.2480864 C59.3363699,41.2478362 64.8552257,37.6448629 65.8607978,31.2927523 C66.7300927,25.8004819 63.2437287,20 63.2437287,20 L63.2437287,20 Z",
    id: "Fill-1",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("text", {
    id: "text1",
    xmlSpace: "preserve",
    x: 30,
    y: 98,
    fontFamily: "OpenSansCondensed-Bold, Open Sans Condensed",
    fontSize: 20,
    fill: "#000000"
  }, "soja"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoy);
export default __webpack_public_path__ + "static/media/soy.42401d02a106949b9cd9e481fa318b96.svg";
export { ForwardRef as ReactComponent };